export default __webpack_public_path__ + "static/media/resume-img.f7ed731d.png";